import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { LogEntry } from './log-entry.entity';

export abstract class LogPublisher {
  location: string;
  abstract log(record: LogEntry): Observable<boolean>;
  abstract clear(): Observable<boolean>;
}

export class LogPublisherConfig {
  loggerName: string;
  loggerLocation: string;
  isActive: boolean;
}

export class LogConsole extends LogPublisher {
  log(record: LogEntry): Observable<boolean> {
    // Log to the console
    console.log(record.buildLogString());
    return of(true);
  }

  clear(): Observable<boolean> {
    console.clear();
    return of(true);
  }
}

export class LogLocalStorage extends LogPublisher {
  constructor() {
    super();
    this.location = 'logging';
  }

  getAll(): Observable<LogEntry[]> {
    let values: LogEntry[];
    // Retrieve all values from local storage
    values = JSON.parse(localStorage.getItem(this.location)) || [];
    return of(values);
  }

  log(record: LogEntry): Observable<boolean> {
    let ret = false;
    let values: LogEntry[];

    try {
      values = JSON.parse(localStorage.getItem(this.location)) || [];
      // Add new log entry to the array
      values.push(record);
      // Store the complete array into local storage
      localStorage.setItem(this.location, JSON.stringify(values));
      ret = true;
    } catch (error) {
      console.log(error);
    }
    return of(ret);
  }

  clear(): Observable<boolean> {
    localStorage.removeItem(this.location);
    return of(true);
  }
}

export class LogWebApi extends LogPublisher {
  constructor(private http: HttpClient) {
    super();
    this.location = `/api/log`;
  }

  log(record: LogEntry): Observable<boolean> {
    return this.http.post(this.location, record).pipe(
      map(data => data),
      catchError(this.handleErrors)
    );
  }

  clear(): Observable<boolean> {
    //TODO: CallWeb Api to clear all log entries
    return of(true);
  }

  private handleErrors(error: any): Observable<any> {
    const errors: string[] = [];
    let msg = '';

    msg = `Status: ${error.Status}`;
    msg += ` - Status Text: ${error.statusText}`;
    if (error) {
      msg += ` - Exception Message: ${error.exceptionMessage}`;
    }

    errors.push(msg);
    console.log('An error occured', errors);
    return throwError(errors);
  }
}
